import DOMPurify from "dompurify";

// Inbound email HTML is attacker-controlled. DOMPurify replaces the former
// hand-written blocklist, which could be bypassed (e.g. "jav&#x09;ascript:"
// links, SVG/MathML payloads) and allowed page-covering overlays.
const EMAIL_PURIFY_CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["style", "form", "input", "button", "textarea", "select", "option", "base", "meta", "link"],
  FORBID_ATTR: ["srcset", "action", "formaction", "ping"],
};
const OVERLAY_POSITION = /position\s*:\s*(?:fixed|sticky)/gi;

const purifier = DOMPurify();
purifier.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noreferrer noopener");
  }
  if (node.tagName === "IMG") {
    node.setAttribute("loading", "lazy");
    node.setAttribute("referrerpolicy", "no-referrer");
  }
  const style = node.getAttribute?.("style");
  if (style && style.match(OVERLAY_POSITION)) {
    node.setAttribute("style", style.replace(OVERLAY_POSITION, "position: static"));
  }
});

export function sanitizeEmailHtml(html) {
  if (!html) return "";
  return purifier.sanitize(String(html), EMAIL_PURIFY_CONFIG);
}

const REPLY_INTRO_PATTERN = /(?:wrote|escreveu|écrit|escribió|ha scritto|schrieb|napisał|написал|写道)\s*[:：]?\s*$/i;

export function sanitizeCurrentEmailHtml(html) {
  const sanitized = sanitizeEmailHtml(html);
  if (!sanitized) return "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitized, "text/html");
  const quotedNodes = [...doc.body.querySelectorAll("blockquote, .gmail_quote, .yahoo_quoted")];

  for (const node of quotedNodes) {
    const previous = node.previousElementSibling;
    const isKnownQuotedContainer = node.classList.contains("gmail_quote") || node.classList.contains("yahoo_quoted");
    const hasReplyIntro = REPLY_INTRO_PATTERN.test(String(previous?.textContent || "").trim());
    if (!isKnownQuotedContainer && !hasReplyIntro) continue;
    if (hasReplyIntro) previous.remove();
    const parent = node.parentElement;
    node.remove();
    if (parent && !String(parent.textContent || "").trim() && !parent.querySelector("img")) parent.remove();
  }

  return doc.body.innerHTML;
}
